import { z } from 'zod';

export const schemaProduktanbieter = z.object({
    logo: z
        .object({
            svg: z.string().optional(),
        })
        .optional(),
    name: z.string().optional(),
});
